module.exports = __webpack_public_path__ + "static/media/alias1.a5195291.gif";